(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-mnz-announcement]';
  const instances = new Map();
  const berlinTime = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23'
  });

  function berlinParts(timestamp) {
    const result = {};
    berlinTime.formatToParts(new Date(timestamp)).forEach(part => {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    });
    return result;
  }

  function nextBerlinMidnight(now) {
    const today = berlinParts(now);
    const target = Date.UTC(today.year, today.month - 1, today.day + 1);
    let midnight = target;

    // Der Offset wird am Zielzeitpunkt berechnet: auch bei Zeitumstellung.
    for (let index = 0; index < 3; index += 1) {
      const local = berlinParts(midnight);
      const correction = target - Date.UTC(
        local.year, local.month - 1, local.day,
        local.hour, local.minute, local.second
      );
      midnight += correction;
      if (correction === 0) break;
    }
    return midnight;
  }

  function renderDigits(container, value) {
    const digits = String(value).padStart(2, '0');
    if (container.textContent !== digits) container.textContent = digits;
  }

  function init(section) {
    if (instances.has(section)) return;
    const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
    const expiration = Number(section.dataset.expirationTime) * 1000;
    const closeButton = section.querySelector('[data-mnz-close]');

    if (!inEditor && Number.isFinite(expiration) && expiration <= Date.now()) {
      section.remove();
      return;
    }

    if (closeButton) {
      const wasClosed = document.cookie.split(';').some(cookie =>
        cookie.trim().startsWith('ecomify-announcement-closed=')
      );
      if (wasClosed && !inEditor) section.hidden = true;

      closeButton.addEventListener('click', () => {
        if (inEditor) return;
        section.hidden = true;
        document.cookie = 'ecomify-announcement-closed=true; max-age=86400; path=/; SameSite=Lax';
      });
    }

    const clocks = Array.from(section.querySelectorAll('[data-mnz-clock]')).map(clock => ({
      element: clock,
      daily: clock.dataset.mode === 'daily',
      deadline: Number(clock.dataset.deadline) * 1000,
      units: ['hours', 'minutes', 'seconds'].map(unit =>
        clock.querySelector('[data-mnz-unit="' + unit + '"]')
      ),
      labels: Array.from(clock.querySelectorAll('.mnz-clock__label')).map(label => label.textContent.trim())
    }));

    let midnight = nextBerlinMidnight(Date.now());

    function update() {
      const now = Date.now();
      if (!inEditor && Number.isFinite(expiration) && expiration <= now) {
        section.remove();
        return;
      }
      if (now >= midnight || midnight - now > 25 * 60 * 60 * 1000) {
        midnight = nextBerlinMidnight(now);
      }

      clocks.forEach(clock => {
        const deadline = clock.daily ? midnight : clock.deadline;
        if (!Number.isFinite(deadline)) {
          clock.element.hidden = true;
          return;
        }
        const remaining = Math.max(0, Math.ceil((deadline - now) / 1000));
        const values = [
          Math.floor(remaining / 3600),
          Math.floor((remaining % 3600) / 60),
          remaining % 60
        ];
        values.forEach((value, index) => renderDigits(clock.units[index], value));
        clock.element.setAttribute('aria-label', values.map((value, index) =>
          value + ' ' + clock.labels[index]
        ).join(', '));
        clock.element.hidden = false;
      });
    }

    const refresh = () => {
      if (document.visibilityState !== 'hidden') {
        midnight = nextBerlinMidnight(Date.now());
        update();
      }
    };
    let interval;
    const cleanup = () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('pageshow', refresh);
      instances.delete(section);
    };
    instances.set(section, cleanup);
    update();
    interval = window.setInterval(() => {
      if (!section.isConnected) {
        cleanup();
        return;
      }
      update();
    }, 1000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, section) => {
      if (event.target === section || event.target.contains(section)) cleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
